import { FileSignatureController } from '@shared/controllers/file-signature.controller';
import { privateFile } from '@shared/helpers/private-file.helper';

export interface PrivateAttachmentUrlOptions {
  poster?: boolean;
  width?: number;
  height?: number;
}

/** Builds an authenticated private-attachment URL, optionally requesting a video poster or thumbnail. */
export function getPrivateAttachmentUrl(
  file: string,
  signatureController: FileSignatureController,
  options: PrivateAttachmentUrlOptions = {}
): string {
  const params = new URLSearchParams();
  const signature = signatureController.getSignature();
  if (signature) params.set('token', signature);
  else if (signatureController.sharedProjectFormToken) params.set('projectFormToken', signatureController.sharedProjectFormToken);
  else if (signatureController.sharedAccessToken) params.set('shareToken', signatureController.sharedAccessToken);

  if (options.poster) params.set('poster', '1');
  if (options.width) {
    params.set('width', String(options.width));
    params.set('height', String(options.height ?? options.width));
  }

  const query = params.toString();
  return query ? `${privateFile(file)}?${query}` : privateFile(file);
}
